import { Navigate, useLocation } from 'react-router-dom';

export const SingularEntityRedirect: React.FC<{ entityName: string }> = ({
  entityName,
}) => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <Navigate
      to={(pathname ?? '').replace(`/${entityName}`, `/${entityName}s`)}
      replace={true}
    />
  );
};
